import { motion } from "motion/react";
import { act, net, pauseMenu } from "../store.js";

/**
 * In-run pause menu (Esc). Best-effort "pause": this overlay halts your input and
 * floats over the world; the authoritative server keeps running (you can't pause
 * other players in co-op), so use Restart/Lobby to actually leave. Resume closes it.
 */
export function PauseMenu() {
  if (!pauseMenu.value) return null;
  const phase = net.value?.runPhase;
  if (phase !== "running" && phase !== "boss") return null;
  const a = act();
  const close = (): void => {
    pauseMenu.value = false;
  };

  return (
    <motion.div
      class="pointer absolute inset-0 z-40 flex flex-col items-center justify-center gap-5 bg-black/60 backdrop-blur-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div class="text-2xl font-extrabold tracking-tight">Paused</div>
      <div class="flex w-64 flex-col gap-3">
        <MenuButton label="Resume" accent="sky" onClick={close} />
        <MenuButton
          label="Restart run"
          accent="amber"
          onClick={() => {
            a?.action("restart");
            close();
          }}
        />
        <MenuButton
          label="Return to lobby"
          accent="rose"
          onClick={() => {
            a?.action("lobby");
            close();
          }}
        />
      </div>
      <p class="text-xs opacity-50">Esc to resume · the world keeps running on the server</p>
    </motion.div>
  );
}

const ACCENTS: Record<string, string> = {
  sky: "border-sky-400/50 bg-sky-500/15 hover:bg-sky-500/30",
  amber: "border-amber-400/50 bg-amber-500/15 hover:bg-amber-500/30",
  rose: "border-rose-400/50 bg-rose-500/15 hover:bg-rose-500/30",
};

function MenuButton({
  label,
  accent,
  onClick,
}: {
  label: string;
  accent: string;
  onClick: () => void;
}) {
  return (
    <motion.button
      type="button"
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.97 }}
      onClick={onClick}
      class={`rounded-xl border px-6 py-3 text-base font-bold tracking-wide ${ACCENTS[accent] ?? ACCENTS.sky}`}
    >
      {label}
    </motion.button>
  );
}
